// extracted by mini-css-extract-plugin
export default {"cls1":"AxZKZG_WXEsEQglMaUjo","cls2":"Z_glRJCl9r6x4dHhr9L0 AxZKZG_WXEsEQglMaUjo"};